module.exports = __webpack_public_path__ + "ea35caa2a1c0b1d30876fb8a429b30e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/landing/fourth_closed.jpg
// module id = 1161
// module chunks = 0